// extracted by mini-css-extract-plugin
module.exports = {"qrWrapper":"landing-mobile-app_qrWrapper__TeyTU"};